import React from 'react';
import { IconExclamationTriangle, IconCircle } from '../ui-kit/icons';
import styled from 'styled-components';
import { worstLevelBackground, getWarningLevelsFromAvailabilityRequirements } from '../../utils/colors';
import DetailsPopover from './DetailsPopover';
import { isEmpty } from 'lodash';

const StatusDot = styled.div`
  color: ${props => props.color};
`;

const redirectToStation = groupId => {
  const url = `/groups/${groupId}`;
  window.open(url);
};

const StationDot = props => {
  const { group } = props;
  const warningLevels = getWarningLevelsFromAvailabilityRequirements(
    group.availability_requirements,
    props.availabilityRequirementState
  );

  if (warningLevels.length === 0) return null;

  const handleClick = e => {
    e.preventDefault();
    redirectToStation(props.group.id);
  };

  const backgroundColor = worstLevelBackground(warningLevels);

  const groupName = props.group.short_code ? props.group.short_code : props.group.name;

  return (
    <DetailsPopover
      key={props.group.id}
      groupName={groupName}
      availabilityRequirements={group.availability_requirements}
      availabilityRequirementState={props.availabilityRequirementState}
      skills={props.skills}
      incidents={props.incidents}
      showIncidents={props.showIncidents}
    >
      <div className="station-warnings">
        <StatusDot onClick={handleClick} color={backgroundColor}>
          {!isEmpty(props.incidents) && props.showIncidents ? (
            <IconExclamationTriangle className="fa-beat-fade fa-2x text-danger" />
          ) : (
            <IconCircle className="fa-2x" />
          )}
        </StatusDot>
      </div>
    </DetailsPopover>
  );
};

export default StationDot;
